import React, { useState } from 'react'
import * as styles from './index.module.css'
import { GatsbyImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import Button from '../Button/'
import Link from '../Link'
import DownCaret from '../../../assets/images/CarrotLG.svg'

const OsSpecifications = ({ subtitle, components, title, images }) => {
  const [expanded, setExpanded] = useState(
    subtitle && subtitle.subtitle === 'expanded'
  )

  const sliderSettings = {
    dots: true,
    infinite: false,
    autoplay: false,
  }

  const expand = () => {
    setExpanded(!expanded)
  }

  const checkForLinkAndRender = (text) => {
    if (text.indexOf('(http') !== -1) {
      let html = text.replace(/\[([^\]]+)\]\(([^)]+)\)/, '<a href="$2">$1</a>')
      return html
    } else {
      return text
    }
  }

  let attrs = []
  const comparisonAttrs = components[0].subtitle.subtitle.trim().split('\n')
  const variants = []
  const comparisons = {}
  const additionalFeatures = []
  const externalLinks = []
  let variantHeaders = ['\t']
  let headerColor = '#754099'

  components.forEach((comp) => {
    if (comp.link === 'comparison') {
      variantHeaders.push(comp.title)
      variants.push(comp.title)
      comparisons[comp.title] = comp.subtitle.subtitle.split('\n')
    } else if (comp.link === 'osComparisonHeaders') {
      return
    } else if (comp.link === 'externalLinks') {
      externalLinks.push(comp)
    } else {
      additionalFeatures.push(comp)
    }
  })

  const specRows = []
  const maxLength = Math.round(attrs.length / 2)

  for (let i = 0; i < maxLength; i++) {
    specRows.push(
      <div className={styles.set}>
        <div className={styles.spec}>
          <span className={styles.label}>{attrs[i].label}</span>
          <div className={styles.attrContainer}>
            {attrs[i].valueSets.map((val, index) => {
              return (
                <span className={styles.value} key={index}>
                  {val.map((subval, idx) => (
                    <span className={styles.subValue} key={idx}>
                      {subval.trim()}
                    </span>
                  ))}
                </span>
              )
            })}
          </div>
        </div>
        {i + maxLength <= attrs.length - 1 && (
          <div className={styles.spec}>
            <span className={styles.label}>{attrs[i + maxLength].label}</span>
            <div className={styles.attrContainer}>
              {attrs[i + maxLength].valueSets.map((val, idx) => (
                <span className={styles.value} key={idx}>
                  {val.map((subval, index) => (
                    <span className={styles.subValue} key={index}>
                      {subval.trim()}
                    </span>
                  ))}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="wrapper">
      <div className={styles.container + ' ' + (expanded && styles.expanded)}>
        <button
          onClick={() => setExpanded(!expanded)}
          className={styles.collapser}
        >
          <h2 className={styles.title}>
            {title}
            <DownCaret className={styles.downCaret} />
          </h2>
        </button>
        <div className={styles.collapsible}>
          {specRows.length > 0 && (
            <div className={styles.specs}>{specRows}</div>
          )}
          {Object.keys(comparisons).length > 0 && (
            <div className={styles.comparisons}>
              <div className={styles.comparisonHeaders}>
                {variantHeaders.map((header, idx) => (
                  <h3
                    key={idx}
                    style={{
                      color:
                        header.split(';').length > 1
                          ? header.split(';')[1]
                          : headerColor,
                    }}
                  >
                    {header.split(';')[0]}
                  </h3>
                ))}
              </div>
              {comparisonAttrs.map((attr, idx) => (
                <div className={styles.comparisonRow} key={idx}>
                  <span className={styles.comparisonAttr}>{attr}</span>
                  {variants.map((variant, index) => (
                    <div className={styles.variantValueRow} key={index}>
                      <span
                        className={styles.mobileVariantName}
                        style={{
                          color:
                            variant.split(';').length > 1
                              ? variant.split(';')[1]
                              : headerColor,
                        }}
                      >
                        {variant.split(';')[0]}
                      </span>
                      <span
                        className={styles.mobileVariantValue}
                        dangerouslySetInnerHTML={{
                          __html: checkForLinkAndRender(
                            comparisons[variant][idx]
                          ),
                        }}
                      ></span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}

          {images && (
            <div>
              <div className={styles.measurements}>
                <GatsbyImage
                  image={images[0].gatsbyImageData}
                  className={styles.measurementImage}
                  alt={images[0]?.description}
                />
                <GatsbyImage
                  image={images[0].gatsbyImageData}
                  className={styles.measurementImage}
                  alt={images[1]?.description}
                />
              </div>
              <div className={styles.mobileMeasurementsImageContainer}>
                <Slider {...sliderSettings}>
                  <div className={styles.carousalImageContainer}>
                    <GatsbyImage
                      image={images[0].gatsbyImageData}
                      style={{ height: '100%', width: '100%' }}
                      alt={images[0]?.description}
                    />
                  </div>
                  <div className={styles.carousalImageContainer}>
                    <GatsbyImage
                      image={images[0].gatsbyImageData}
                      style={{ height: '100%', width: '100%' }}
                      alt={images[1]?.description}
                    />
                  </div>
                </Slider>
              </div>
            </div>
          )}

          <div className={styles.additionalFeatures}>
            <h3 className={styles.additionalFeaturesHeading}>
              {additionalFeatures[0].title}
            </h3>
            <ul className={styles.featurelist}>
              {additionalFeatures[0].subtitle.subtitle
                .trim()
                .split('\n')
                .map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
            </ul>

            {externalLinks.length > 0 && (
              <div className={styles.externalLinks}>
                {externalLinks.map((component, idx) => (
                  <Link
                    to={component.ctaUrl}
                    key={idx}
                    children={
                      <Button className={styles.externalLink}>
                        {component.ctaText}
                      </Button>
                    }
                  ></Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OsSpecifications
